export const DEFAULT_STRING = {
    NO_NAME: "<NoName>",
    UNKNOWN: "<Unknown>",
}